module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"coming_soon":"Coming soon..."},"fr":{"coming_soon":"Bientôt disponible..."}}')
  delete Component.options._Ctor
}
